
import { useState } from 'react';

const WHATSAPP_NUMBER = '351962050526';
const WHATSAPP_MESSAGE = 'Olá! Gostaria de obter mais informações sobre os apartamentos.';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap border border-gray-100">
          Fale connosco no WhatsApp
        </div>
      </div>

      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="w-14 h-14 flex items-center justify-center rounded-full shadow-xl cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-2xl"
        style={{ backgroundColor: '#25D366' }}
        aria-label="Contactar via WhatsApp"
      >
        {/* Pulse ring */}
        <span className="absolute w-14 h-14 rounded-full animate-ping opacity-30" style={{ backgroundColor: '#25D366' }}></span>
        <i className="ri-whatsapp-line text-white text-2xl relative z-10"></i>
      </a>
    </div>
  );
};

export default WhatsAppButton;
